<ion-app>
  <ion-split-pane contentId="main-content">
<!--    <ion-menu contentId="main-content" type="overlay">-->
<!--      <ion-content>-->
<!--          <ion-list-header>CELLA IN TRANSIT</ion-list-header>-->

<!--          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages; let i = index">-->
<!--            <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">-->
<!--              <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>-->
<!--              <ion-label>{{ p.title }}</ion-label>-->
<!--            </ion-item>-->
<!--          </ion-menu-toggle>-->

<!--      </ion-content>-->
<!--    </ion-menu>-->
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
